module.exports = __webpack_public_path__ + "static/media/banner4.ed508e72.png";